import Cookies, { CookieAttributes } from 'js-cookie';

import { ICookieExpiryOptions } from '@manage-cards/types/extra.types';

export const formatDateDDMMYYYY = (date: number) =>
	new Intl.DateTimeFormat('en-UK', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	}).format(new Date(date));

export const getUrlParams = (param: string): string | null => {
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get(param);
};

function _getCookieExpiry(expiry?: ICookieExpiryOptions): Date | undefined {
	if (!expiry) return;
	const { days = 0, minutes = 0, hours = 0 } = expiry;
	let expiresInMillisecons = minutes;
	if (hours) {
		expiresInMillisecons += hours * 60;
	}
	if (days) {
		expiresInMillisecons += days * 60 * 24;
	}
	expiresInMillisecons = expiresInMillisecons * 60 * 1000;
	return new Date(new Date().getTime() + expiresInMillisecons);
}

export function setCookie(
	cookieName: string,
	cookieValue: string,
	options: Omit<CookieAttributes, 'expires'> & {
		expires?: ICookieExpiryOptions;
	} = {},
) {
	return Cookies.set(cookieName, cookieValue, {
		...options,
		expires: _getCookieExpiry(options.expires),
	});
}

export function getCookie(cookieName: string) {
	return Cookies.get(cookieName) ?? '';
}

/* NOTE: Commented for future use
 export function deleteCookie(cookieName: string, options?: CookieAttributes) {
	return Cookies.remove(cookieName, options);
} */
